import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApprovalListAsync } from '../ApprovalStore/approvalSlice';
import { Box } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import { userKycListColumn } from './column';
import useToast from '../../../hooks/useToast';
import { storeUserKycApiStatus } from './UserKycApproveStore/userKycApproveSlice';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';

function UserKycApprove() {
  const { ErrorToast } = useToast();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('pending');
  const [userIdKyc, setUserIdKyc] = useState('');

  const PER_PAGE = 10;

  const STATUS_OPTION = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approve', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
  ];

  const { userKycListData, userKycCount } = useSelector(
    ({ approvalReducer }) => {
      return {
        userKycListData: approvalReducer.userKycList,
        userKycCount: approvalReducer.userKycCount,
      };
    }
  );

  useEffect(() => {
    dispatch(
      getApprovalListAsync({
        params: {
          entityType: 'kyc',
          approvalType: 'user-kyc-status',
          limit: PER_PAGE,
          page: 1,
          statuses: ['pending'],
          latestFirst: true,
        },
        type: 'userKyc',
      })
    );
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'user-kyc-status',
            limit: PER_PAGE,
            page: val,
            statuses: [status],
            latestFirst: true,
          },
          type: 'userKyc',
        })
      )
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            ErrorToast(res.message);
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  const handleStatus = (e) => {
    console.log({ e: e.target.value });
    setStatus(e.target.value);
    dispatch(storeUserKycApiStatus(e.target.value));

    if (userIdKyc !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'user-kyc-status',
            limit: PER_PAGE,
            page: 1,
            statuses: [e.target.value],
            secondaryFilter: { userId: userIdKyc },
            latestFirst: true,
          },
          type: 'userKyc',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'user-kyc-status',
            limit: PER_PAGE,
            page: 1,
            statuses: [e.target.value],
            latestFirst: true,
          },
          type: 'userKyc',
        })
      );
    }
  };

  const handleSearchUserKyc = () => {
    console.log('search user kyc by user id', userIdKyc);
    if (userIdKyc !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'user-kyc-status',
            limit: 10,
            page: 1,
            statuses: [status],
            secondaryFilter: { userId: userIdKyc },
            latestFirst: true,
          },
          type: 'userKyc',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'kyc',
            approvalType: 'user-kyc-status',
            limit: 10,
            page: 1,
            statuses: [status],
            latestFirst: true,
          },
          type: 'userKyc',
        })
      );
    }
  };

  return (
    <Box py={4}>
      <Box
        borderBottom={`1px solid #dfdfdf`}
        pb={2}
        mb={4}
        fontSize={22}
        fontWeight={'fontWeightMedium'}>
        User KYC Approval
      </Box>
      <Box mb={2} display="flex">
        <Box mr={4} width={350}>
          <BuzzInput
            fullWidth={true}
            placeholder={'Search school KYC by user id'}
            search
            value={userIdKyc}
            onChange={(e) => setUserIdKyc(e.target.value)}
            onSubmitEditing={handleSearchUserKyc}
            size="small"
            label="Seach school KYC"
          />
        </Box>
        <Box>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select status'}
            value={status}
            onChange={handleStatus}
            label="Select status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
      </Box>
      <BuzzTable columns={userKycListColumn} data={userKycListData} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={userKycCount}
          pageNo={page}
          defaultPage={1}
          perPage={PER_PAGE}
        />
      </Box>
    </Box>
  );
}

export default UserKycApprove;
